// @ts-check

// Keep these aligned with Create Announcement (Announcement DataForm).
const ANNOUNCEMENT_TITLE_MIN_LENGTH = 5;
const ANNOUNCEMENT_CONTENT_MIN_LENGTH = 5;

/* eslint-disable max-len */
const ERROR_ANNOUNCEMENT_TITLE_MIN_LENGTH = `Please use a minimum of ${ANNOUNCEMENT_TITLE_MIN_LENGTH} characters in your Announcement Title.`;
const ERROR_ANNOUNCEMENT_CONTENT_MIN_LENGTH = `Please include at least ${ANNOUNCEMENT_CONTENT_MIN_LENGTH} characters in your Announcement Content.`;
const ERROR_ANNOUNCEMENT_DATE_RANGE = `End Date cannot be before Start Date.`;
/* eslint-enable max-len */

export {
  ANNOUNCEMENT_TITLE_MIN_LENGTH,
  ANNOUNCEMENT_CONTENT_MIN_LENGTH,
  ERROR_ANNOUNCEMENT_TITLE_MIN_LENGTH,
  ERROR_ANNOUNCEMENT_CONTENT_MIN_LENGTH,
  ERROR_ANNOUNCEMENT_DATE_RANGE,
};
